//Original
// import { httpClient } from 'utils/httpClient';
// import {authenticationService}  from 'services/Authentications/authenticationService';

// export function apiFactory(http) {
//   return {
//     authentication: authenticationService(http)
//   };
// }

// const http = httpClient();
// export const api = apiFactory(http);

// -------------Mine----------------
import { httpClient } from 'utils/httpClient';
import { authenticationService }  from 'services/Authentications/authenticationService';
import { userService } from 'services/Apis/GeneralServices/userService';
import { inOutService } from 'services/Apis/GeneralServices/inOutService';
import { internalTelServices } from 'services/Apis/GeneralServices/internalTelServices';
import { timesheetService } from 'services/Apis/TimesheetServices/timesheetService'
import { costCenterService } from 'services/Apis/CostCenterServices/costCenterService'

const authenticateUrl = "https://localhost:44378/api";
const intranetUrl = "https://localhost:44337/api";

// const authenticateUrl = "http://intranet:3000/Authentication/api";
// const intranetUrl = "http://intranet:3000/Intranet/api";

export function apiFactory(http) {
  return {
    authentication: authenticationService(http),
    generalInformation: userService(http),
    inOut: inOutService(http),
    internalTel: internalTelServices(http),
    timesheet: timesheetService(http),
    costCenter: costCenterService(http)
  };
}


const http = httpClient(authenticateUrl);
const intranetHttp = httpClient(intranetUrl);

export const api = apiFactory(http); 
export const intranetApi = apiFactory(intranetHttp);

